import { AgmCoreModule } from '@agm/core';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { GoogleMapsConfig } from './google-maps.interface';

@NgModule({
  exports: [AgmCoreModule],
})
export class GoogleMapsModule {
  static forRoot(mapsConfig: GoogleMapsConfig): ModuleWithProviders {
    return AgmCoreModule.forRoot(mapsConfig);
  }
}
